import React, { createContext, useContext, useState, useEffect } from 'react';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within a LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  // TEMPORARILY DISABLED: Arabic version is disabled
  // Check localStorage or default to English
  const [isArabic, setIsArabic] = useState(() => {
    // Force English - Arabic temporarily disabled
    // return false;
    const saved = localStorage.getItem('language');
    return saved === 'ar';
  });

  const toggleLanguage = () => {
    // Arabic temporarily disabled - do nothing
    // return;
    setIsArabic(prev => {
      const newValue = !prev;
      localStorage.setItem('language', newValue ? 'ar' : 'en');
      return newValue;
    });
  };

  const setLanguage = (lang) => {
    // Arabic temporarily disabled - force English
    // setIsArabic(false);
    // localStorage.setItem('language', 'en');
    const isAr = lang === 'ar';
    setIsArabic(isAr);
    localStorage.setItem('language', lang);
  };

  // Set document direction and language
  useEffect(() => {
    if (isArabic) {
      document.documentElement.dir = 'rtl';
      document.documentElement.lang = 'ar';
      // Dynamically import RTL styles
      import('../styles/rtl.css');
    } else {
      document.documentElement.dir = 'ltr';
      document.documentElement.lang = 'en';
    }
  }, [isArabic]);

  return (
    <LanguageContext.Provider value={{ isArabic, toggleLanguage, setLanguage }}>
      {children}
    </LanguageContext.Provider>
  );
};

